import React, { useCallback, useEffect, useState } from "react";
import HtmlInput from "../forms/input";
import { IconSearch } from "../icons";

const getAddressProp = (values, name) => {
    if (!values) return null;
    return values.find((x) => x.types && x.types.includes(name));
};

const getStreetNumber = (unit, streetNumber) => {
    if (unit) return `${unit.long_name}/${streetNumber.long_name}`;
    return streetNumber.long_name;
};

const GooglePlaces = (props) => {
    const {
        name,
        onPlaceChanged,
        onTextChanged,
        countries,
        defaultValue,
        ...others
    } = props;

    const [value, setValue] = useState("");

    useEffect(() => {
        setValue(defaultValue ?? "");
    }, [defaultValue]);

    useEffect(() => {
        var input = document.getElementById(name);
        input.value = defaultValue;
        var autocomplete = new google.maps.places.Autocomplete(input, {
            componentRestrictions: countries ? { country: countries } : {},
        });
        google.maps.event.addListener(
            autocomplete,
            "place_changed",
            function () {
                var place = autocomplete.getPlace();
                const address = place.address_components;

                const unit = getAddressProp(address, "subpremise");
                const streetNumber = getAddressProp(address, "street_number");
                const streetName = getAddressProp(address, "route");
                const suburb = getAddressProp(address, "locality");
                const state = getAddressProp(
                    address,
                    "administrative_area_level_1"
                );
                const postcode = getAddressProp(address, "postal_code");
                const country = getAddressProp(address, "country");

                const data = {
                    unit: unit?.long_name,
                    streetNumber: streetNumber?.long_name,
                    streetName: streetName?.long_name,
                    streetNameShort: streetName?.short_name,
                    suburb: suburb?.long_name,
                    state: state?.long_name,
                    stateShort: state?.short_name,
                    postcode: postcode?.long_name,
                    country: country?.long_name,
                    countryShort: country?.short_name,
                    fullAddress: `${getStreetNumber(unit, streetNumber)} ${
                        streetName.long_name
                    }, ${suburb.long_name} ${state.short_name}, ${
                        postcode.long_name
                    }`,
                };

                setValue(data.fullAddress);

                if (onPlaceChanged) onPlaceChanged(data);
            }
        );
    }, []);

    const handleOnChange = useCallback((e) => {
        setValue(e.target.value);
    }, []);

    useEffect(() => {
        if (onTextChanged) onTextChanged(value);
    }, [value]);

    return (
        <HtmlInput
            name={name}
            onChange={handleOnChange}
            value={value}
            {...others}
            postIcon={<IconSearch />}
        />
    );
};

export default GooglePlaces;
